/**
 * OOTB file
 */
'use strict';
import wishlist from './wishlist/wishlist';
import giftCardDetail from './giftCard/giftCard';
var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(wishlist);
    processInclude(giftCardDetail);
});
